import React from 'react';
import HelpCircle from "./HelpCircle";
import {AlertCircle} from "lucide-react";

const TikTokMetaDataForm = ({getDeclaration, handlePrivacyStatusChange,handleTitleChange,creatorInfo,seriesData,setShowHoverNotification,handleTiktokMetadataChange,showHoverNotification,tiktokPostMetadata,handleCommercialContentChange}) => {
    return <div className='lg:col-span-1 overflow-auto'>
        <h4 className='text-2xl font-semibold mb-4'>TikTok Post Settings</h4>
        {creatorInfo && (
            <p className='mb-4'>
                Posting to TikTok account:{' '}
                <strong>{creatorInfo.tikTokNickname}</strong>
            </p>
        )}
        <div className='space-y-4'>
            <div>
                <label className='block mb-2'>Title</label>
                <input
                    type='text'
                    name='title'
                    value={tiktokPostMetadata.title}
                    onChange={handleTitleChange}
                    className='w-full p-2 border rounded'
                    autoFocus
                />
            </div>
            <div>
                <label className='block mb-2'>Privacy Status</label>
                <select
                    name='privacyStatus'
                    value={tiktokPostMetadata.privacyStatus}
                    onChange={handlePrivacyStatusChange}
                    className='w-full p-2 border rounded'
                >
                    <option value=''>Select privacy status</option>
                    {creatorInfo &&
                        creatorInfo.privacyLevelOptions &&
                        creatorInfo.privacyLevelOptions.map((option) => (
                            <option
                                key={option}
                                value={option}
                                // disabled={isPrivacyOptionDisabled(option)}
                            >
                                {option}
                            </option>
                        ))}
                </select>
            </div>
            <div>
                <label
                    className={`flex items-center ${
                        creatorInfo?.commentDisabled
                            ? 'opacity-50 cursor-not-allowed'
                            : ''
                    }`}
                >
                    <input
                        type='checkbox'
                        name='allowComments'
                        checked={tiktokPostMetadata.allowComments}
                        onChange={handleTiktokMetadataChange}
                        disabled={creatorInfo?.commentDisabled}
                        className={`mr-2 ${
                            creatorInfo?.commentDisabled
                                ? 'opacity-50 cursor-not-allowed'
                                : ''
                        }`}
                    />
                    Allow Comments
                </label>
                {creatorInfo?.commentDisabled && (
                    <p className='text-sm text-gray-500 mt-1'>
                        Comments are disabled in your TikTok app settings.
                    </p>
                )}
            </div>
            {seriesData.contentType !== 'Photo' && (
                <>
                    <div>
                        <label
                            className={`flex items-center ${
                                creatorInfo?.duetDisabled
                                    ? 'opacity-50 cursor-not-allowed'
                                    : ''
                            }`}
                        >
                            <input
                                type='checkbox'
                                name='allowDuet'
                                checked={tiktokPostMetadata.allowDuet}
                                onChange={handleTiktokMetadataChange}
                                disabled={creatorInfo?.duetDisabled}
                                className={`mr-2 ${
                                    creatorInfo?.duetDisabled
                                        ? 'opacity-50 cursor-not-allowed'
                                        : ''
                                }`}
                            />
                            Allow Duet
                        </label>
                        {creatorInfo?.duetDisabled && (
                            <p className='text-sm text-gray-500 mt-1'>
                                Duets are disabled in your TikTok app settings.
                            </p>
                        )}
                    </div>
                    <div>
                        <label
                            className={`flex items-center ${
                                creatorInfo?.stitchDisabled
                                    ? 'opacity-50 cursor-not-allowed'
                                    : ''
                            }`}
                        >
                            <input
                                type='checkbox'
                                name='allowStitch'
                                checked={tiktokPostMetadata.allowStitch}
                                onChange={handleTiktokMetadataChange}
                                disabled={creatorInfo?.stitchDisabled}
                                className={`mr-2 ${
                                    creatorInfo?.stitchDisabled
                                        ? 'opacity-50 cursor-not-allowed'
                                        : ''
                                }`}
                            />
                            Allow Stitch
                        </label>
                        {creatorInfo?.stitchDisabled && (
                            <p className='text-sm text-gray-500 mt-1'>
                                Stitches are disabled in your TikTok app settings.
                            </p>
                        )}
                    </div>
                </>
            )}
            <div
                onMouseEnter={() => setShowHoverNotification(true)}
                onMouseLeave={() => setShowHoverNotification(false)}
            >
                <label className='flex items-center'>
                    <input
                        type='checkbox'
                        name='commercialContent'
                        checked={tiktokPostMetadata.commercialContent}
                        onChange={handleCommercialContentChange}
                        className='mr-2'
                    />
                    Commercial Content
                </label>
            </div>
            {tiktokPostMetadata.commercialContent && (
                <div className='ml-6 space-y-4'>
                    <div className='relative'>
                        <HelpCircle content="Your photo/video will be labeled as 'Promotional content'">
                            <label className='flex items-center'>
                                <input
                                    type='checkbox'
                                    name='yourBrand'
                                    checked={tiktokPostMetadata.yourBrand}
                                    onChange={handleTiktokMetadataChange}
                                    className='mr-2'
                                />
                                Your Brand
                            </label>
                        </HelpCircle>
                        {tiktokPostMetadata.yourBrand && (
                            <p className='text-sm text-gray-600 ml-6'>
                                Your photo/video will be labeled as 'Promotional content'
                            </p>
                        )}
                    </div>
                    <div className='relative'>
                        <HelpCircle content="Your photo/video will be labeled as 'Paid partnership'">
                            <label className='flex items-center'>
                                <input
                                    type='checkbox'
                                    name='brandedContent'
                                    checked={tiktokPostMetadata.brandedContent}
                                    onChange={handleTiktokMetadataChange}
                                    className='mr-2'
                                />
                                Branded Content
                            </label>
                        </HelpCircle>
                        {tiktokPostMetadata.brandedContent && (
                            <p className='text-sm text-gray-600 ml-6'>
                                Your photo/video will be labeled as 'Paid partnership'
                            </p>
                        )}
                    </div>
                </div>
            )}
        </div>
        <div className='mt-6'>
            <p className='text-sm text-gray-600'>{getDeclaration()}</p>
        </div>
        {showHoverNotification && tiktokPostMetadata.commercialContent && (
            <div className='absolute bg-white border border-gray-200 shadow-lg p-2 rounded-md z-10'>
                <div className='flex items-center'>
                    <AlertCircle className='text-yellow-500 mr-2' size={16} />
                    <span className='text-sm'>
                {tiktokPostMetadata.privacyStatus === 'Self Only'
                    ? "Branded content can't be set to 'Self Only'. Please change the privacy setting."
                    : 'You need to indicate if your content promotes yourself, a third party, or both'}
              </span>
                </div>
            </div>
        )}
    </div>
};

export default TikTokMetaDataForm;
